import { render } from "./TableInvoice.vue?vue&type=template&id=9af7dab0"
import script from "./TableInvoice.vue?vue&type=script&lang=ts"
export * from "./TableInvoice.vue?vue&type=script&lang=ts"
script.render = render

export default script